module.exports = __webpack_public_path__ + "img/alicloud-white.836af760.svg";